@if (typeInfo(); as type) {
  <div
    class="flex max-w-[100px] items-center gap-1 rounded-xl px-2"
    [ngClass]="type.backgroundColour"
  >
    <span>{{ type.label }}</span>
    <mat-icon>{{ type.icon }}</mat-icon>
  </div>
}
